import { css } from "styled-components"
import { CARD_SIZES } from "./constants"

export const cardSizeStyle = css`
  max-width: ${(p) => CARD_SIZES[p.size]};
`
